module.exports = __webpack_public_path__ + "static/media/jm.b7b13124.svg";